import { useDispatch } from 'react-redux'
import PendingI from '@mui/icons-material/Remove'
import { IconButton, Tooltip } from '@mui/material'
import { INVOICE_STATUS } from '../../../constants'
import {
  CFDIPaymentStatusIconMap,
  CFDIPaymentStatusLabelMap,
} from 'lib/utils/Invoices/invoices.utils'
import { setSelectedInvoice as setSelectedInvoiceRedux } from 'actions/invoices'
import { useCFDIsContainerContext } from 'containers/Invoices/CFDIs/CFDIsContainer/CFDIsContainer'
import Activity from 'components/Shared/Activity/Activity'

interface IPaymentStatusProps {
  status: any
  row: any
  addTooltip?: boolean
  returnLabel?: boolean
}

const CFDIPaymentStatus = ({
  status,
  row,
  addTooltip = false,
  returnLabel = false,
}: IPaymentStatusProps) => {
  const { changeCfdiPaymentStatusMutation, updateState } =
    useCFDIsContainerContext()

  const { isLoading } = changeCfdiPaymentStatusMutation

  const dispatch = useDispatch()

  const label = CFDIPaymentStatusLabelMap[status?.value] ?? 'Pendiente'
  const Icon = CFDIPaymentStatusIconMap[status?.value] ?? PendingI

  return (
    <div className="status-container payment-status">
      {(row?.status !== INVOICE_STATUS.ACTIVE.id || !row?.uuid) && (
        <PendingI className="status-payment-icon canceled" color="inherit" />
      )}
      {row?.status === INVOICE_STATUS.ACTIVE.id && row?.uuid && (
        <>
          {isLoading && <Activity size={20} color="primary" local />}
          {!isLoading && addTooltip && (
            <Tooltip
              title={
                changeCfdiPaymentStatusMutation.isLoading ? 'Espera...' : label
              }>
              <IconButton
                size="small"
                onClick={e => {
                  e.stopPropagation()
                  if (changeCfdiPaymentStatusMutation.isLoading) return
                  updateState(draft => {
                    draft.paymentStatusAnchor = e.currentTarget
                    draft.activeInvoice = row
                  })
                  dispatch(setSelectedInvoiceRedux(row))
                }}
                disableRipple>
                <Icon
                  className={`status-payment-icon ${status?.value || ''}`}
                  color="inherit"
                />
              </IconButton>
            </Tooltip>
          )}
          {!isLoading && !addTooltip && (
            <IconButton
              size="small"
              onClick={e => {
                e.stopPropagation()
                if (changeCfdiPaymentStatusMutation.isLoading) return
                updateState(draft => {
                  draft.paymentStatusAnchor = e.currentTarget
                  draft.activeInvoice = row
                })
                dispatch(setSelectedInvoiceRedux(row))
              }}
              disableRipple>
              <Icon
                className={`status-payment-icon ${status?.value || ''}`}
                color="inherit"
              />
            </IconButton>
          )}
        </>
      )}
      {returnLabel && label}
    </div>
  )
}

export default CFDIPaymentStatus
